import { createStructuredSelector } from "reselect"
import { selectOrganizationDesign, selectActionCenterSettings } from "QuorumGrassroots/framework/selectors"

const styledComponentConnection = createStructuredSelector({
    organizationDesign: selectOrganizationDesign,
    actionCenterSettings: selectActionCenterSettings,
})

export default styledComponentConnection
